import { InvoiceModel }      from '../../../app-lite/invoices/models/invoice';
import { MessagesService }   from '../../../app-lite/messages/messages.service';
import { SessionService } from '../../../app-lite/sessions/session.service';

export class DepositCtrl {
  $uibModalInstance: ng.ui.bootstrap.IModalInstanceService;
  currencySymbol   : string;
  Deposit          : any;
  deposit          : any;
  invoice          : InvoiceModel;
  messages         : MessagesService;
  paymentMethods   : Array<any>;
  sessionObjAPI    : SessionService;

  constructor (
    $uibModalInstance: ng.ui.bootstrap.IModalInstanceService,
    Deposit          : any,
    deposit          : any,
    invoice          : InvoiceModel,
    messages         : MessagesService,
    paymentMethods   : Array<any>,
    sessionObjAPI    : SessionService
  ) {
    this.$uibModalInstance = $uibModalInstance;
    this.Deposit           = new Deposit(invoice, deposit, paymentMethods);
    this.deposit           = deposit;
    this.invoice           = invoice;
    this.messages          = messages;
    this.paymentMethods    = paymentMethods;
    this.sessionObjAPI     = sessionObjAPI;

    this.currencySymbol = this.sessionObjAPI.currency().symbol;
  }

  add () : void {
    this.Deposit.validate()
    .then(() => this.$uibModalInstance.close(this.Deposit.deposit))
    .catch(err => {
      this.messages.error(err);
    });
  }
}
